// Fix for collection page swatches not loading images
document.addEventListener('DOMContentLoaded', function() {
  
  function fixCollectionSwatches() {
    const swatches = document.querySelectorAll('.collection-color-swatch');
    
    swatches.forEach((swatch, index) => {
      const title = swatch.getAttribute('title');
      const currentStyle = swatch.getAttribute('style');
      
      if (!title || !currentStyle) return;
      
      // Check if it's trying to load a background image
      if (currentStyle.includes('background-image')) {
        const imageUrlMatch = currentStyle.match(/background-image:\s*url\(([^)]+)\)/);
        if (imageUrlMatch) {
          const imageUrl = imageUrlMatch[1].replace(/['\"]/g, '');
          
          // Test if the image loads
          const testImg = new Image();
          testImg.onload = function() {
            // Image loaded successfully, no action needed
          };
          
          testImg.onerror = function() {
            applyFallbackColor(swatch, title);
          };
          
          testImg.src = imageUrl;
        }
      } else if (currentStyle.includes('background-color')) {
        // Already has a background color, but might need better color mapping
        const hasValidColor = currentStyle.match(/background-color:\s*([^;]+)/);
        if (!hasValidColor || !hasValidColor[1] || hasValidColor[1].trim() === title.toLowerCase()) {
          applyFallbackColor(swatch, title);
        }
      } else {
        applyFallbackColor(swatch, title);
      }
    });
  }
  
  function applyFallbackColor(swatch, colorName) {
    // Use the same brand colors as the product page
    const colorMap = {
      'Red': '#E31E24',           // Brand red
      'Green': '#00A651',         // Brand green  
      'Blue': '#0066B3',          // Brand blue
      'Burgundy': '#800020',
      'Dark Blue': '#003366',
      'Navy': '#001f3f',
      'Black': '#000000',
      'White': '#ffffff',
      'Brown': '#8b4513',
      'Gray': '#808080',
      'Grey': '#808080',
      'Yellow': '#FFC20E',        // Brand yellow
      'Orange': '#ff6b35',
      'Purple': '#6b46c1',
      'Pink': '#ec4899'
    };
    
    const fallbackColor = colorMap[colorName] || '#cccccc';
    swatch.style.backgroundImage = 'none';
    swatch.style.backgroundColor = fallbackColor;
    
    // Add border for light colors
    if (['White', 'Light Blue', 'Yellow', 'Cream', 'Light Gray'].includes(colorName)) {
      swatch.style.border = '1px solid #ddd';
    }
  }
  
  // Run the fix
  fixCollectionSwatches();
  
  // Also run when new products are loaded (infinite scroll, filtering, etc.)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // Check if new product cards were added
        const hasNewSwatches = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('card-wrapper') ||
            node.querySelector?.('.collection-color-swatch')
          )
        );
        
        if (hasNewSwatches) {
          setTimeout(fixCollectionSwatches, 100);
        }
      }
    });
  });
  
  // Watch for changes in the product grid
  const productGrid = document.querySelector('.collection') || document.querySelector('.grid--contains-card');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
});